import axios from 'axios';

/**
 * API Base URL from environment variable
 * Set REACT_APP_API_URL in your .env file
 * Example: REACT_APP_API_URL=https://api.irrigationplusky.com
 */
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:9000';

/**
 * Public axios instance for unauthenticated requests (login, signup)
 */
export const publicAxios = axios.create({
    baseURL: API_URL,
});

/**
 * Authenticated axios instance with Bearer token interceptor
 */
export const authAxios = axios.create({
    baseURL: API_URL,
});

authAxios.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Handle inactive entities by returning empty data
authAxios.interceptors.response.use(response => {
    if (response.data && response.data.isActive === false) {
        response.data = {};
    }
    return response;
});

export default authAxios;
